// app/javascript/projects/components/UserDisplayDivider.jsx

import React from 'react';

function UserDisplayDivider(props) {
  return <div style={{borderBottom:"1px solid lightGray"}}/>
}

export default UserDisplayDivider